import React from 'react';
import { useAppStore } from 'store/app-store.hook';
import { useToasts } from 'react-toast-notifications';

export const useToastNotifications = () => {
  const { addToast } = useToasts();
  const { successMessage, error, clearSuccessMessage, clearErrorMessage } = useAppStore().ui.toastStore;

  React.useEffect(() => {
    if (successMessage) {
      addToast(successMessage, { appearance: 'success', autoDismiss: true });
      clearSuccessMessage();
    }
  }, [addToast, clearSuccessMessage, successMessage]);

  React.useEffect(() => {
    if (error) {
      addToast(
        <div>
          <div>Error: {error.message}</div>
          <div>id: {error.id}</div>
        </div>,
        { appearance: 'error', autoDismiss: false },
      );
      clearErrorMessage();
    }
  }, [addToast, clearErrorMessage, error]);
};
